import React from 'react';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/layout/header';
import Main from './components/layout/main';
import Navigation from './components/layout/navigation';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ToastContainer } from 'react-toastify';


function App() {

  const user = JSON.parse(localStorage.getItem('bwf-user'));

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider user={user}>
        <div className="App">
          <Router>
            <div className="content-container">
              <Header />
              <Main />
            </div>
            <Navigation />
          </Router>
        </div>
        <ToastContainer position="bottom-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
